import { useFormik } from 'formik';
import React, { Fragment, useEffect, useState } from 'react';
import { genderOptions } from '../../users/Constant';
import { useDispatch, useSelector } from 'react-redux';
import { useGetStates } from '../../../hooks/useGetStates';
import Loader from '../../../components/Loader/Loader';
import { Button, Col, Form, Row } from 'reactstrap';
import TextInput from '../../../components/InputFields/TextInput';
import { updateMyProfile } from '../../../api/User';
import { failed, success } from '../../../utils/Tostify';
import moment from 'moment';
import DatePickerSelector from '../../../components/InputFields/DatePicker';
import {formikUser} from "./Constant";
import MultiSelect from '../../../components/InputFields/MultiSelect';
import { languageOptions } from '../../patient/Constant';
import { useLocation, useNavigate } from 'react-router';


const EditProfile = () => {
  let token = useSelector(state => state.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [Countryvalue, setCountryValue] = useState();
  const [stateValue, setStateValue] = useState();
  const { states, countryOptions } = useGetStates(Countryvalue);
  const location = useLocation();
  const user = location?.state?.userDetails;
  const [userData, setUserData] = useState(user);
  const navigate = useNavigate();


  const formik = useFormik({
    ...formikUser,
    onSubmit: async (values) => {
      let res;
      try {
        values.language =  values.language?.map(option => option.value) || []; // Extract only 'value'
        setIsLoading(true);
        res = await updateMyProfile({ values, dispatch, token, userId: userData?._id });
        if (res?.status == "SUCCESS") {
          setIsLoading(false);
          success(res?.message);
          navigate("/app/profile");
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      } catch (error) {
        setIsLoading(false);
        failed(res?.message);
      }
    }
  });

  const CountrychangeHandler = e => {
    setCountryValue(e.target.value);
    formik.setFieldValue("country", countryOptions.find((obj) => obj.value === e.target.value).label);
  };

  const stateHandler = (e) => {
    setStateValue(e.target.value);
    formik.setFieldValue('state', e.target.value);
  };

  useEffect(() => {
    const transformToOptionFormat = (options) => {
      if (options && options.length > 0) {
        return options.map((option) => ({
          label: option,
          value: option
        }));
      }
      return options;
    };
    formik.setFieldValue("firstName", userData?.firstName);
    formik.setFieldValue("lastName", userData?.lastName);
    formik.setFieldValue("email", userData?.email);
    formik.setFieldValue("gender", userData?.gender);
    formik.setFieldValue("dob", moment(userData?.dob).format("MM-DD-YYYY") );
    formik.setFieldValue("role", userData?.role);
    formik.setFieldValue("jobTitle", userData?.jobTitle);
    formik.setFieldValue("primaryPhone", userData?.primaryPhone);
    formik.setFieldValue("secondaryPhone", userData?.secondaryPhone);
    formik.setFieldValue("city", userData?.city);
    formik.setFieldValue("address", userData?.address);
    formik.setFieldValue("postalCode", userData?.postalCode);
    formik.setFieldValue("country", userData?.country);
    formik.setFieldValue("employer", userData?.employer);
    formik.setFieldValue("department", userData?.department);
    formik.setFieldValue("roles", userData?.roles);
    formik.setFieldValue("about", userData?.about);
    formik.setFieldValue("language", transformToOptionFormat(userData?.language));
    setCountryValue(countryOptions?.find((obj) => obj.label === userData?.country)?.value);
    formik.setFieldValue("state", userData?.state);
    setStateValue(userData?.state);
  }, [userData]);

  return (
    <Fragment>
    <div className='profile_container'>
        <h3 className='edit_o_blk'>Edit Profile</h3>
        <Form onSubmit={formik.handleSubmit}>
            {isLoading ? <Loader /> : null}
            <div className="organization_form_block organization_blk p-0 m-0 organization_modal modal_change_color modal_pro_file">
              <div className="forms_block  modal_change_color p-3" style={{gap:'0'}}>
                <div className="first_block">
                  <Row>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"firstName"}
                        formik={formik}
                        label="First Name"
                        type="text"
                        placeholder="First Name"
                        value={formik.values.firstName}
                        onChange={(e) => formik.setFieldValue("firstName", e.target.value)}
                        autoFocus={true}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"lastName"}
                        formik={formik}
                        label="Last Name"
                        placeholder={"Last Name"}
                        type="text"
                        value={formik.values.lastName}
                        onChange={(e) => formik.setFieldValue("lastName", e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"gender"}
                        formik={formik}
                        label="Gender"
                        type="select"
                        required={false}
                        options={genderOptions}
                        placeholder="gender"
                        value={formik.values.gender}
                        onChange={(e) => formik.setFieldValue("gender", e.target.value)}
                      />
                    </Col>
                    <Col lg={6} className="location_block modal_pro_file">
                      <DatePickerSelector
                        keyField={"dob"}
                        formik={formik}
                        value={formik.values?.dob}
                        minDate={""}
                        maxDate={moment()}
                        label="Date Of Birth"
                        type="date"
                        onChange={(e) => formik.setFieldValue("dob", moment(e).format("MM-DD-YYYY"))}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="first_block">
                  <h6 className="block_name my-2">Contact Information</h6>
                  <Row>
                    <Col lg={12} className="location_block">
                      <TextInput
                        keyField={"email"}
                        formik={formik}
                        label="Email"
                        type="email"
                        placeholder="Email"
                        readOnly={true}
                        value={formik.values.email}
                        onChange={(e) => formik.setFieldValue("email", e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"primaryPhone"}
                        formik={formik}
                        label="Phone"
                        type="phone"
                        placeholder="Phone"
                        value={formik.values.primaryPhone}
                        onChange={(e) => formik.setFieldValue("primaryPhone", e)}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"secondaryPhone"}
                        formik={formik}
                        label="Secondary Phone"
                        type="phone"
                        placeholder="Secondary Phone"
                        required={false}
                        value={formik.values.secondaryPhone}
                        onChange={(e) => formik.setFieldValue("secondaryPhone", e)}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="first_block second_block">
                  <h6 className="block_name my-2"> Address Information</h6>
                  <Row>
                    <Col lg={12} className="location_block">
                      <TextInput
                        keyField={"address"}
                        formik={formik}
                        label="Street"
                        type="text"
                        placeholder="Street"
                        value={formik.values.address}
                        onChange={(e) => formik.setFieldValue("address", e.target.value)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"country"}
                        formik={formik}
                        options={countryOptions}
                        label="Country"
                        type="select"
                        // placeholder="Country"
                        value={Countryvalue}
                        onChange={CountrychangeHandler}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"state"}
                        formik={formik}
                        label="State"
                        options={states.map((obj) => {
                          return {
                            label: obj.name,
                            value: obj.name
                          };
                        })}
                        type="select"
                        placeholder="State"
                        value={stateValue}
                        onChange={stateHandler}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"city"}
                        formik={formik}
                        label="City"
                        type="text"
                        placeholder="City"
                        value={formik.values.city}
                        onChange={(e) => formik.setFieldValue("city", e.target.value)}
                      />
                    </Col>
                    <Col lg={6} className="location_block">
                      <TextInput
                        keyField={"postalCode"}
                        formik={formik}
                        label="Zip Code"
                        type="text"
                        placeholder="Zip Code"
                        value={formik.values.postalCode}
                        onChange={(e) => formik.setFieldValue("postalCode", e.target.value)}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="first_block second_block">
                  <div className="second_block">
                    <h6 className="block_name my-2">Misc Information</h6>
                    <Row>
                    <Col lg={6} className="location_block doc_type_blkk ">
                    <MultiSelect
                        keyField={"language"}
                        formik={formik}
                        required={false}
                        type="select"
                        label="Language Preference"
                        placeholder="Select"
                        options={languageOptions}
                        value={formik.values.language}
                        onChange={(e) =>
                            formik.setFieldValue("language", e)
                        }
                        />
                    </Col>
                    </Row>
                    <Row>
                        <Col lg={12} className="location_block">
                        <TextInput
                            keyField={"about"}
                            formik={formik}
                            label="About"
                            required={false}
                            type="text"
                            placeholder="About"
                            value={formik.values.about}
                            onChange={(e) => formik.setFieldValue("about", e.target.value)}
                        />
                        </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="schedule_task d-flex gap-4 justify-content-center">
                <Button className="primary" type="submit"> Save</Button>
                <Button className="secondary" type="button" onClick={()=>navigate("/app/profile")}>Close</Button>
          </div>
        </Form>
    </div>
    </Fragment>
  );
};

export default EditProfile;
